<template>
  <div class="technology">
    <div class="m-top-box">
      <Nav />
      <div class="m-layout-center"></div>
    </div>
    <div class="m-layout-center">
      <img src="../assets/images/industry1.png" alt="" class="u-bg-img2" />
      <img src="../assets/images/industry2.png" alt="" class="u-bg-img2" />
      <img src="../assets/images/industry3.png" alt="" class="u-bg-img2" />
    </div>
  </div>
</template>
<style scoped lang="scss">
@mixin textStyle {
  font-size: 16px;
  color: #787878;
}
@mixin textStyle2 {
  font-size: 16px;
  color: #787878;
  text-indent: 50px;
  line-height: 36px;
}
.u-bg-img2 {
  display: block;
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
}
.m-top-box {
  width: 100%;
  padding-top: 10px;
  height: 660px;
  background: url(https://static.gzldyg.cn/group3/M00/06/1F/CgEyJmHziiCAXkkUAAT4JtvG95c186.png)
    no-repeat center top;
  background-size: cover;
  h2 {
    color: #fff;
    font-size: 32px;
    font-weight: 500;
    text-align: center;
    height: 100px;
    line-height: 100px;
    margin-top: 166px;
  }
}
.sol-msg {
  @include textStyle2;
  margin-bottom: 50px;
}
.m-platform {
  text-align: center;
  p {
    @include textStyle;
  }
  img {
    width: 1000px;
    height: 640px;
  }
}
.m-con {
  p {
    @include textStyle2;
  }
  .integrated {
    width: 1000px;
    height: 488px;
  }
  .data {
    width: 900px;
    height: 660px;
  }
}
.bannerWrap {
  width: 100%;
  height: 400px;
  position: relative;
  z-index: 999;
}
.slide {
  width: 100%;
  height: 100%;
  position: relative;
  li {
    width: 100%;
    height: 400px;
    opacity: 0;
    filter: alpha(opacity=0);
    position: absolute;
    left: 0;
    top: 0;
  }
  &:first-child {
    display: block;
    opacity: 1;
    z-index: 10;
  }
}
.slide_but {
  width: 700px;
  position: absolute;
  z-index: 9999;
  bottom: 14px;
  left: 50%;
  margin-left: -350px;
  text-align: center;
  li {
    display: inline-block;
    width: 8px;
    height: 8px;
    margin: 0 10px;
    background: transparent;
    cursor: pointer;
    border: 2px solid #d7d7d7;
    border-radius: 50%;
    opacity: 0.75;
    filter: alpha(opacity=75);
    *display: inline;
  }
  .active {
    background: #007aff;
    border-color: #fff;
    opacity: 1;
    filter: alpha(opacity=100);
  }
}
</style>
<script>
import Nav from "@/components/Nav.vue";


export default {
  name: "technology",
  components: {
    Nav,
  }
};
</script>